export default "__VITE_ASSET__NLFb$Lmu__"